import { getTutorialHelpBadge } from './helpStatus';

/**
 * Tutoriels actifs avec étiquette d’aide (nouveau / mis à jour), sur les thèmes fournis
 * (l’API /help/video-themes applique déjà le périmètre application).
 */
export function getUnviewedCount(themes) {
  if (!Array.isArray(themes)) return 0;
  let n = 0;
  for (const theme of themes) {
    const list = theme?.tutorials;
    if (!Array.isArray(list)) continue;
    for (const t of list) {
      if (getTutorialHelpBadge(t) != null) n += 1;
    }
  }
  return n;
}

export function countTutorialsNeedingAttention(themes) {
  return getUnviewedCount(themes);
}
